import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { BlockingLoadingSpinnerComponent } from '@softline/application';
import { ApplicationRef, Injector, DOCUMENT } from '@angular/core';


export async function block<T = void>(
  callback: () => Promise<T>,
  injector: Injector
): Promise<T> {
  const document = injector.get(DOCUMENT);
  const appRef = injector.get(ApplicationRef);
  const portal = new ComponentPortal(BlockingLoadingSpinnerComponent);
  const outlet = new DomPortalOutlet(document.body, appRef);
  outlet.attach(portal);
  try {
    const result = await callback();
    return result;
  } catch (e) {
    console.error(e);
    throw e;
  } finally {
    outlet.detach();
  }
}
